import Vue from 'vue';
import axios from 'axios';

Vue.mixin({
  methods: {

    cornerComecaMinuto(c){
      // corner10
      if(c == 9){ return  "-" }
      // corner20
      if(c == 10){ return "Palpite aberto até minuto 9'" }
      // corner30
      if(c == 11){ return "Palpite aberto até minuto 19'" }
      // corner40
      if(c == 12){ return "Palpite aberto até minuto 29'" }
      // corner50
      if(c == 13){ return "Palpite aberto até minuto 49'" }
      // corner60
      if(c == 14){ return "Palpite aberto até minuto 59'" }
      // corner70
      if(c == 15){ return "Palpite aberto até minuto 69'" }
      // corner80
      if(c == 16){ return "Palpite aberto até minuto 79'" }

      // goals_25
      if(c == 17){ return "-" }
      // goals_45
      if(c == 18){ return "Palpite aberto até minuto 24'" }
      // goals_75
      if(c == 19){ return "Palpite aberto até minuto 49'" }
      // goals_90
      if(c == 20){ return "Palpite aberto até minuto 75'" }

      return "-";
    },

    nomeMercadoEscolhido(c){
      // corner10
      if(c == 9){ return  'DO MINUTO 0:00 ATÉ 9:59?' }
      // corner20
      if(c == 10){ return 'DO MINUTO 10:00 ATÉ 19:59?' }
      // corner30
      if(c == 11){ return 'DO MINUTO 20:00 ATÉ 29:59?' }
      // corner40
      if(c == 12){ return 'DO MINUTO 30:00 ATÉ 39:59?' }
      // corner50
      if(c == 13){ return 'DO MINUTO 50:00 ATÉ 59:59?' }
      // corner60
      if(c == 14){ return 'DO MINUTO 60:00 ATÉ 69:59?' }
      // corner70
      if(c == 15){ return 'DO MINUTO 70:00 ATÉ 79:59?' }
      // corner80
      if(c == 16){ return 'DO MINUTO 80:00 ATÉ 88:59?' }

      // goals_25
      if(c == 17){ return "DO MINUTO 0:00 ATÉ 25:59?" }
      // goals_45
      if(c == 18){ return "DO MINUTO 26:00 ATÉ 44:59?'" }
      // goals_75
      if(c == 19){ return "DO MINUTO 50:00 ATÉ 75:59?'" }
      // goals_90
      if(c == 20){ return "DO MINUTO 76:00 ATÉ 89:59?'" }

      return "-";
    },

    slide_inicio(grupo){
      if(grupo == 1){ return 3; }
      if(grupo == 2){ return 6; }
      if(grupo == 3){ return 9; }
      if(grupo == 4){ return 12; }
      if(grupo == 5){ return 15; }
      if(grupo == 6){ return 18; }
      if(grupo == 7){ return 21; }
      if(grupo == 8){ return 24; }
      if(grupo == 9){ return 27; }
    },

    slide_fim(grupo){
      if(grupo == 1){ return 5; }
      if(grupo == 2){ return 8; }
      if(grupo == 3){ return 11; }
      if(grupo == 4){ return 14; }
      if(grupo == 5){ return 17; }
      if(grupo == 6){ return 20; }
      if(grupo == 7){ return 23; }
      if(grupo == 8){ return 26; }
      if(grupo == 9){ return 29; }
    },

    atualize_menu(){
          let a = JSON.parse(localStorage.getItem("user"))
          let user = null

          if (a == null){
            user = {}
          }else{
            user = a
          }

          var base = 'https://tt2.sokkerduel.com/'

          var header = {'headers': {'x-access-token': user.access_token, }};
          axios.get(base+'user', header)
          .then(response => {
            let a = response.data.data
            user.balance = a.balance
            user.balance_convidado = a.balance_convidado

            localStorage.setItem("user", JSON.stringify(user));
          })
          .catch(e => {
            console.log(e)
            alert('errro na atualização do menu')
          });

          return 'ok'
    },

    traducao_opcao(n){
        let aux = ''
        switch (n) {
          case '1 WIN': aux = 'Casa';  break;
          case '2 WIN' : aux = 'Fora'; break;
          case 'DRAW' : aux = 'Empate'; break;
          case '1 WIN OR DRAW' : aux = 'Casa ou Empate'; break;
          case '1 OR 2' : aux = 'Casa ou Fora'; break;
          case '2 WIN OR DRAW' : aux = 'Fora ou Empate'; break;

          case 'Over 0.5' : aux = 'Mais de 0.5'; break;
          case 'Over 1.5' : aux = 'Mais de 1.5'; break;
          case 'Over 2.5' : aux = 'Mais de 2.5'; break;
          case 'Over 3.5' : aux = 'Mais de 3.5'; break;
          case 'Over 4.5' : aux = 'Mais de 4.5'; break;
          case 'Over 8.5' : aux = 'Mais de 8.5'; break;
          case 'Over 9.5' : aux = 'Mais de 9.5'; break;
          case 'Over 10.5' : aux = 'Mais de 10.5'; break;

          case 'Under 0.5' : aux = 'Menos de 0.5'; break;
          case 'Under 1.5' : aux = 'Menos de 1.5'; break;
          case 'Under 2.5' : aux = 'Menos de 2.5'; break;
          case 'Under 3.5' : aux = 'Menos de 3.5'; break;
          case 'Under 4.5' : aux = 'Menos de 4.5'; break;
          case 'Under 8.5' : aux = 'Menos de 8.5'; break;
          case 'Under 9.5' : aux = 'Menos de 9.5'; break;
          case 'Under 10.5' : aux = 'Menos de 10.5'; break;

          case 'YES' : aux = 'Sim'; break;
          case 'NO' : aux = 'Não'; break;
        }
        return aux
    },

    //sair
    expluse_para_login(){
      // alert("Sua acessão expirou!")
      // localStorage.setItem("user", null)

      localStorage.removeItem("user")
      this.$router.push({ path: '/login', replace: true })
      return
    },

    //status nome do torneio
    torneio_tipo_nome(id){
      let aux = ''
      switch (id) {
        case 1: aux = '1 Contra 1';  break;
        case 2: aux = 'Prêmio Fixo';  break;
        case 3: aux = 'Torneio Grátis';  break;
        case 4: aux = 'Turbo';  break;
      }
      return aux
    },

    //status nome do torneio
    torneio_status_nome(id){
      let aux = ''
      switch (id) {
        case 0: aux = 'Pendente';  break;
        case 1: aux = 'Aberto';  break;
        case 2: aux = 'Aguardando início';  break;
        case 3: aux = 'Acontecendo';  break;
        case 4: aux = 'Finalizado';  break;
        case 5: aux = 'Não aconteceu';  break;
        case 6: aux = 'Cancelado';  break;
        case 7: aux = 'Pré Finalizado'; break;
      }
      return aux
    },


    extrato_status_nome(id){
      let aux = ''
      switch (id) {
        case 0: aux = 'Pendente';  break;
        case 1: aux = 'Confirmado';  break;
        case 2: aux = 'Bloqueado';  break;
        case 3: aux = 'Em Análise';  break;
        case 4: aux = 'Processado';  break;
        case 5: aux = 'Error';  break;
      }
      return aux
    },


    //status de alertas
    alerta_status_nome(n){
      let aux = 'Aconteceu um error inesperado! :('
      switch (n) {
        case 'cpf_existente': aux = 'CPF já existe! ';  break;
        case 'username_existente': aux = 'USERNAME já existe! ';  break;
        case 'email_existente': aux = 'EMAIL já existe! ';  break;
      }
      return aux
    },

    //converte timestamp para data BR ex: 18/11/2022 17:30:00
    /*
    timestamp_dataBR(timestamp, modelo = 0)
    {

      try {

          //modelos de saidas
          //modelo == 0 (default): 18/11/2022 17:30:00
          //modelo == 1 : 18/11

          const dtFormat1 = new Intl.DateTimeFormat('sv-SE', {
            year: 'numeric', month: 'numeric', day: 'numeric',
            hour: 'numeric', minute: 'numeric', second: 'numeric',
            hour12: false,
            // timeStyle: 'medium',
            timeZone: 'America/Sao_Paulo'
            //timeZone: this.user.timezone,
          });

          let t = dtFormat1.format( new Date( timestamp * 1000 )).replace(/\//g, '-')

          var data = new Date(t),
          dia  = data.getDate().toString(),
          diaF = (dia.length == 1) ? '0' + dia : dia,
          mes  = (data.getMonth()+1).toString(),
          mesF = (mes.length == 1) ? '0' + mes : mes,
          anoF = data.getFullYear();

          var hour = String(data.getHours());
          var hourF = (hour.length == 1) ? '0' + hour : hour;
          var minute = String(data.getMinutes());
          var minuteF = (minute.length == 1) ? '0' + minute : minute;
          var segundo = String(data.getSeconds());
          var segundoF = (segundo.length == 1) ? '0' + segundo : segundo

          if(modelo == 1 ){
            return diaF+"/"+mesF
          }
          if(modelo == 2 ){
            return hourF+":"+minuteF+":"+segundoF
          }
          if(modelo == 3){
            return diaF+"/"+mesF+" "+hourF+":"+minuteF
          }
          if(modelo == 4){
            return diaF+"/"+mesF+" | "+hourF+":"+minuteF
          }
          if(modelo == 5){
            return diaF+"/"+mesF+"/"+anoF+" | "+hourF+":"+minuteF
          }
          if(modelo == 0 ){
            return diaF+"/"+mesF+"/"+anoF+" "+hourF+":"+minuteF+":"+segundoF
          }

      } catch (error) {
        return "-"
      }

    },
    */


    timestamp_dataBR(timestamp, modelo = 0) {
      try {
          const data = new Date(timestamp * 1000);

          const dia = data.getDate().toString().padStart(2, '0');
          const mes = (data.getMonth() + 1).toString().padStart(2, '0');
          const ano = data.getFullYear();

          const hour = data.getHours().toString().padStart(2, '0');
          const minute = data.getMinutes().toString().padStart(2, '0');
          const segundo = data.getSeconds().toString().padStart(2, '0');

          switch (modelo) {
              case 1:
                  return `${dia}/${mes}`;
              case 2:
                  return `${hour}:${minute}:${segundo}`;
              case 3:
                  return `${dia}/${mes} ${hour}:${minute}`;
              case 4:
                  return `${dia}/${mes} | ${hour}:${minute}`;
              case 5:
                  return `${dia}/${mes}/${ano} | ${hour}:${minute}`;
              case 0:
              default:
                  return `${dia}/${mes}/${ano} ${hour}:${minute}:${segundo}`;
          }
      } catch (error) {
          return "-";
      }
   },





    //previsao de termino
    previsao_termino(timestamp, modelo = 0){

      try {

          //coloca mais uns 10 minutos a frente
          const dtFormat1 = new Intl.DateTimeFormat('sv-SE', {
            year: 'numeric', month: 'numeric', day: 'numeric',
            hour: 'numeric', minute: 'numeric', second: 'numeric',
            hour12: false,
            timeZone: 'America/Sao_Paulo'
          });

          //let t = dtFormat1.format( new Date( (timestamp * 1000) + 600000   )).replace(/\//g, '-')
          let t = dtFormat1.format( new Date( (timestamp * 1000) )).replace(/\//g, '-')

          var data = new Date(t),
          dia  = data.getDate().toString(),
          diaF = (dia.length == 1) ? '0' + dia : dia,
          mes  = (data.getMonth()+1).toString(),
          mesF = (mes.length == 1) ? '0' + mes : mes,
          anoF = data.getFullYear();

          var hour = String(data.getHours());
          var hourF = (hour.length == 1) ? '0' + hour : hour;
          var minute = String(data.getMinutes());
          var minuteF = (minute.length == 1) ? '0' + minute : minute;
          var segundo = String(data.getSeconds());
          var segundoF = (segundo.length == 1) ? '0' + segundo : segundo

          if(modelo == 1){
            return diaF+"/"+mesF
          }
          if(modelo == 2){
            return hourF+":"+minuteF+":"+segundoF
          }
          if(modelo == 3){
            return diaF+"/"+mesF+" "+hourF+":"+minuteF
          }
          if(modelo == 4){
            return diaF+"/"+mesF+" | "+hourF+":"+minuteF
          }
          if(modelo == 0){
            return diaF+"/"+mesF+"/"+anoF+" "+hourF+":"+minuteF+":"+segundoF
          }

      } catch (error) {
          return "-"
      }

    },


    //converte timestamp para horas/minutos/segundos ex: 20:55:23
    timestamp_horas_minutos_segundos(diferenca){
      if(diferenca > 0){
        let hor = Math.trunc(diferenca / 3600)
        let min = Math.trunc(diferenca % 3600 / 60)
        let s = Math.trunc(diferenca % 60)
        hor = (hor<=9) ? '0' + hor : hor
        min = (min<=9) ? '0' + min : min
        s = (s<=9) ? '0' + s : s
        return hor+":"+min +":"+ s
      }else{
        return 0
      }
    },

    //formato de moeda
    formatarMoeda(valor) {

      if(valor == null){
        return '0,00';
      }

      if (isNaN(valor)) {
        return '0,00';
      } else {
        return parseFloat(valor).toLocaleString('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      }
    },


    set_local_storate(balance, balance_convidado){
      //edite o local storage ------
      let u = JSON.parse(localStorage.getItem("user"))
      u.balance = balance
      u.balance_convidado = balance_convidado
      localStorage.setItem("user", JSON.stringify(u));

      return 'ok'
    },

    dateBR(inputDate) {
      if(inputDate == null){ return null  }

      const parts = inputDate.split(" ");
      const datePart = parts[0];
      const timePart = parts[1];

      const dateComponents = datePart.split("-");
      const year = dateComponents[0];
      const month = dateComponents[1];
      const day = dateComponents[2];

      return `${day}/${month}/${year} ${timePart}`;
    },

    dateBR2(inputDate) {

      if(inputDate == null){ return null }

      const parts = inputDate.split(" ");
      const datePart = parts[0];
      const timePart = parts[1];

      const dateComponents = datePart.split("-");
      const year = dateComponents[0];
      const month = dateComponents[1];
      const day = dateComponents[2];

      return `${day}/${month}/${year}`;
    },

    validarCPF(cpf) {

      cpf = cpf.replace(/\D/g, '');

      if (cpf == '11111111111'){return false}
      if (cpf == '22222222222'){return false}
      if (cpf == '33333333333'){return false}
      if (cpf == '44444444444'){return false}
      if (cpf == '55555555555'){return false}
      if (cpf == '66666666666'){return false}
      if (cpf == '77777777777'){return false}
      if (cpf == '88888888888'){return false}
      if (cpf == '99999999999'){return false}

      // Remover caracteres não numéricos
      cpf = cpf.replace(/\D/g, '');

      // Verificar se o CPF tem 11 dígitos
      if (cpf.length !== 11) {
          // alert('CPF inválido. Deve conter 11 dígitos.');
          return false;
      }

      // Calcular o primeiro dígito verificador
      var soma = 0;
      for (var i = 0; i < 9; i++) {
          soma += parseInt(cpf.charAt(i)) * (10 - i);
      }
      var primeiroDigito = 11 - (soma % 11);
      if (primeiroDigito > 9) {
          primeiroDigito = 0;
      }

      // Calcular o segundo dígito verificador
      soma = 0;
      for (var i = 0; i < 10; i++) {
          soma += parseInt(cpf.charAt(i)) * (11 - i);
      }
      var segundoDigito = 11 - (soma % 11);
      if (segundoDigito > 9) {
          segundoDigito = 0;
      }

      // Verificar se os dígitos verificadores estão corretos
      if (parseInt(cpf.charAt(9)) !== primeiroDigito || parseInt(cpf.charAt(10)) !== segundoDigito) {
          return false
      } else {
          return true
      }
    },

    validar_email(email) {
      const regexEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return regexEmail.test(email);
    },

  }
});


// WEBPACK FOOTER //
// ./src/helpers/funcoes.js